import React, { useState, useEffect } from 'react';
import { 
         Grid,
         IconButton,
         Paper,
         Switch,
         TextField,
        } from '@material-ui/core';
import {       
            PermIdentity as PermIdentityIcon,
            Search as SearchIcon,
        } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import CambiarZona from './components/CambiarZona';
import { 
    Tooltip as TooltipAntd, 
} from 'antd';

function CambioZona(){
    const { authTokens, setRuta } = useAuth(); 
    const [ DatosF, setDatosF] = useState({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:'', Zona:''});
    const { enqueueSnackbar } = useSnackbar();
    const [ dataClientes, setDataClientes ] = useState([]);
    const [ userName, setUserName ] = useState('');
    const [ showAutocomplete, setShowAutocomplete ] = useState(true);
    const [ dataZona, setDataZona ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState('');
    const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
    const [ isSelectedZona, setSelectedZona ] = useState(false);
    const [ isClientSelected, setClientSelected ] = useState(false);
    const [ arrZonas, setArrZonas ] = useState([]);
    const [ arrAps, setArrAps ] = useState([]);
    const [ getPlanes, setPlanes ] = useState([]);
    


    useEffect(
        ()=>{
            async function ReqInfo() {
                setRuta('/Clientes/CambiarZona');
                const dataZonas = await fetch(`/api/Zonas/byEmpresa/${authTokens.Empresa}`);
                const resultZonas = await dataZonas.json();
                const getAp = await fetch('/api/equipos');
                const arr_Ap = await getAp.json();
                const dataPlanes = await fetch(`/api/PlanesbyEmpresa/${authTokens.Empresa}`);
                const resuPlanes = await dataPlanes.json();
                setPlanes(resuPlanes);
                setArrAps(arr_Ap);
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZonas);
                }else{
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona.toString()))
                    setDataZona(arrFilZona); 
                }  
            };
        
            ReqInfo();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(isSelectedZona){
            const handleForZona = async () =>{ 
                const dataClientes =  await fetch('/api/clientes');
                const resultClientes = await dataClientes.json();
                const arrClientes = [];
                for(const x in resultClientes){
                    const objeto = {...resultClientes[x]};
                    const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService.toString() === zonaSelected.toString());
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }
                }
                setSelectedZona(true);
                setDataClientes(arrClientes);
            };

            handleForZona();
        }
    },[isSelectedZona]); // eslint-disable-line react-hooks/exhaustive-deps



    const handleDatos = (e) =>{ setDatosF({...DatosF, [e.target.id]: e.target.value}) };

    const handleSearchCedula = async ()=>{
        if(DatosF.CI === '' || DatosF.CI.length < 4){
            enqueueSnackbar('C.I. INCORRECTO', {variant:'error'});
        }else{
            fetch('/api/clientes/cedula',{
                method:'POST',
                body: JSON.stringify({CI:DatosF.CI, Zona:zonaSelected}),
                headers:{'Content-Type': 'application/json'}
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.noServices){
                    Swal.fire({
                        title:'CLIENTE SIN SERVICIOS',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:450,
                        toast:true
                    }) 
                }else if(result.message){
                    Swal.fire({
                        title:'NO EXISTE ESTE ID',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:450,
                        toast:true
                    }) 
                }else if(result.Info){
                    Swal.fire({
                        title:'CLIENTE TIENE SERVICIOS EN OTRAS ZONAS',
                        text:result.Info,
                        icon:'info',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:750
                    })              
                }else if(result.status){  
                    Swal.fire({
                        title:result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:450,
                        toast:true
                    });
                }else{
                    enqueueSnackbar('Cliente Seleccionado', {variant:'info'}); 
                    setDatosF(result);
                    setClientSelected(true);
                }
            });
            
        }
    };

    const handleResetCliente = ()=>{      
        setDatosF({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:''});
        setUserName('');
        setClientSelected(false);        
    };

    const handleShowAutocomplete = (e)=>{
        setDatosF({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:''});
        setUserName('');
        setShowAutocomplete(e.target.checked);
        setClientSelected(false);
    };

    const handleSelectName = (value)=>{
        new Promise((resolver, rechazar)=>{
            setUserName(value);
            const arrFil = dataClientes.filter(value2=>value2.Nombres.toString() === value.toString());
            if(arrFil.length === 1) {
                if(arrFil[0].Servicios.length === 0){
                    Swal.fire({
                        title:`ESTE CLIENTE NO TIENE SERVICIOS`,
                        icon:'info',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:750,
                        toast:true,
                    })
                }else{
                    resolver(arrFil[0]);
                }
            }
        })
        .then((inf)=>{
            enqueueSnackbar('Cliente Seleccionado', {variant:'info'}); 
            setDatosF(inf);
            setClientSelected(true);
        })
        .catch((err)=>{
            alert(`Error en el Sistema: ${err}`)
        });
    };

    const handleClearZona = ()=>{
        setZonaSelected('');
        setSelectedZona(false);
        setDatosF({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:''});
        setUserName('');
        setShowAutocomplete(true);
        setClientSelected(false);
    };

    const handleSelectZona = (valZ)=>{
        setZonaSelected(valZ);
        const arrFil =  (dataZona.filter(value=> value.Zona.toString() === valZ.toString()))[0];
        const arrFil2 = dataZona.filter(value=> value.Zona.toString() !== valZ.toString());
        setArrZonas(arrFil2);
        setZonaSelectedObject(arrFil);
        setSelectedZona(true);
        setClientSelected(false);
    };


    return(
                <Paper elevation={3} style={{padding:15, width:'100%', minHeight:20, maxHeight:900, maxWidth:500, margin:5}}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={9}>
                            <Autocomplete
                                id="Zona"
                                options={dataZona.map(value=>value.Zona)}
                                value={zonaSelected || ''}                              
                                renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearZona()
                                    }else{
                                        handleSelectZona(value);
                                    }
                                }}  
                            />
                        </Grid>
                        <Grid item xs={3}>   
                            <TooltipAntd title="NOMBRES O CI" color='BLUE' >
                                <Switch checked={showAutocomplete || false} onChange={handleShowAutocomplete} name="showAutocomplete" />
                            </TooltipAntd>                                             
                        </Grid>
                        <Grid item xs={12} >
                        {
                            showAutocomplete ?
                                <Autocomplete
                                    id="Nombres"
                                    options={dataClientes.map(value=>value.Nombres)}
                                    value={userName || ''}    
                                    disabled={!isSelectedZona}                          
                                    renderInput={(params) => <TextField {...params} label="Nombres" variant="outlined" size='small' fullWidth />}
                                    onChange={(e,value, reason)=>{
                                        if(reason ===  'clear'){
                                            handleResetCliente()
                                        }else{
                                            handleSelectName(value);
                                        }
                                    }}  
                                />:
                                <TextField 
                                    id='CI'
                                    fullWidth
                                    label='id'
                                    value={DatosF.CI || ''}
                                    onChange={handleDatos}
                                    InputProps={{
                                        startAdornment: <PermIdentityIcon color='primary'/>,
                                        endAdornment: 
                                        <IconButton aria-label="search" onClick={handleSearchCedula}  disabled={!isSelectedZona} size='small'>
                                            <SearchIcon color='primary' />
                                        </IconButton>
                                    }}
                                    onKeyPress={(e)=>{
                                        const code = e.keyCode || e.which;
                                        if(code === 13)
                                        handleSearchCedula();
                                        }}
                                    variant='outlined'
                                    size='small'
                                    disabled={!isSelectedZona}
                                />
                        }
                        </Grid>
                        {
                            isClientSelected &&
                            <Grid item xs={12} style={{margin:'0px auto', height:450, overflowY:'auto', }}>
                                {
                                    DatosF.Servicios.map((el, index)=>(
                                        <CambiarZona 
                                            data={ el }
                                            arrZonas={ arrZonas } 
                                            zonaSelectedObject={ zonaSelectedObject }
                                            zonaSelected={ zonaSelected }
                                            isSelectedZona={ isSelectedZona }
                                            arrAps={ arrAps }
                                            dataCliente={ DatosF }
                                            key={`ElementoZona_${index}-${el._id}`}
                                            getPlanes={getPlanes}
                                        />
                                    ))
                                }
                                
                            </Grid>
                        }
                        
                    </Grid>   
                </Paper>
    );
};

function ChangeZona(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <CambioZona />
        </SnackbarProvider>
    );
};

export default ChangeZona;